import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
    const [SpOrders, setpOrders] = useState(0);
    const [pNetSales, setpNetSales] = useState(0);
    const [totalOrders, setTotalOrders] = useState(0);
    const [PrvTotalOrders, setprvTotalOrders] = useState(0);
    const [Perc1, setPerc1] = useState(0);
    const [percStyle, setPercStyle] = useState('green');
    const [urlDsh, setUrlDsh] = useState('');
    const [nameDsh, setNameDsh] = useState('');
    const [percIconClass, setPercIconClass] = useState("fas fa-caret-up dshsqrlbl");
    const [percCashOrds, setpercCashOrds] = useState("0");
    const [percStyleCashOrds, setPercStyleCashOrds] = useState('green');
    const [percIconClassCashOrds, setPercIconClassCashOrds] = useState("fas fa-caret-up dshsqrlbl");
    const [CashOrders, setCashOrders] = useState(0);
    const [prvCashOrders, setprvCashOrders] = useState(0);
    const [CreditOrders, setCreditOrders] = useState(0);
    const [percCreditOrders, setpercCreditOrders] = useState("0");
    const [percStyleCreditOrders, setPercStyleCreditOrders] = useState('green');
    const [percIconClassCreditOrders, setPercIconClassCreditOrders] = useState("fas fa-caret-up dshsqrlbl");
    const [PrvCreditOrders, setPrvCreditOrders] = useState(0);
    const [NetSal, setnetsal] = useState(0);
    const [PrvNetSal, setprvNetSal] = useState(0);
    const [PercNetSal, setPercNetSal] = useState(0);
    const [percStyleNetSal, setPercStyleNetSal] = useState('green');
    const [percIconClassNetSal, setPercIconClassNetSal] = useState("fas fa-caret-up dshsqrlbl");
    const [Gross, setGross] = useState(0);
    const [PrvGross, setprvGross] = useState(0);
    const [PercGross, setPercGross] = useState(0);
    const [percStyleGross, setPercStyleGross] = useState('green');
    const [percIconClassGross, setPercIconClassGross] = useState("fas fa-caret-up dshsqrlbl");
    const [Disc, setDisc] = useState(0);
    const [PrvDisc, setprvDisc] = useState(0);
    const [PercDisc, setPercDisc] = useState(0);
    const [percStyleDisc, setPercStyleDisc] = useState('green');
    const [percIconClassDisc, setPercIconClassDisc] = useState("fas fa-caret-up dshsqrlbl");
    const [VAT, setVAT] = useState(0);
    const [PrvVAT, setprvVAT] = useState(0);
    const [PercVAT, setPercVAT] = useState(0);
    const [percStyleVAT, setPercStyleVAT] = useState('green');
    const [percIconClassVAT, setPercIconClassVAT] = useState("fas fa-caret-up dshsqrlbl");
    const [Cash, setCash] = useState(0);
    const [PrvCash, setprvCash] = useState(0);
    const [PercCash, setPercCash] = useState(0);
    const [percStyleCash, setPercStyleCash] = useState('green');
    const [percIconClassCash, setPercIconClassCash] = useState("fas fa-caret-up dshsqrlbl");
    const [Credit, setCredit] = useState(0);
    const [PrvCredit, setprvCredit] = useState(0);
    const [PercCredit, setPercCredit] = useState(0);
    const [percStyleCredit, setPercStyleCredit] = useState('green');
    const [percIconClassCredit, setPercIconClassCredit] = useState("fas fa-caret-up dshsqrlbl");
    const [Bnk, setBnk] = useState(0);
    const [PrvBnk, setprvBnk] = useState(0);
    const [PercBnk, setPercBnk] = useState(0);
    const [percStyleBnk, setPercStyleBnk] = useState('green');
    const [percIconClassBnk, setPercIconClassBnk] = useState("fas fa-caret-up dshsqrlbl");
    const now = new Date()
    const [FrmDt, setFrmDt] = useState(now.toISOString().split('T')[0]);
    const [ToDt, setToDt] = useState(now.toISOString().split('T')[0]);
    const formatDate = (dateString) => {

        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    useEffect(() => {
        if (window.DshName === "FADash") {
            setUrlDsh("ShwSalesDashPart1");
            setNameDsh("Sales DashBoard");
        }
        else {
            setUrlDsh("ShwPOSDashPart1");
            setNameDsh("POS DashBoard");
        }
    }, []);
    useEffect(() => {
        setpOrders(window.pOrders);
        setpNetSales(window.pNetSales)
        if (urlDsh) {
            fetch(`/Home/${urlDsh}/`)
                .then(response => response.json())
                .then(data => {
                    var b = JSON.parse(data);
                    const TotalOrders = parseFloat(b.TotalOrders.replace(/,/g, ''));
                    const prevTotalOrders = parseFloat(b.PrvTotalOrders.replace(/,/g, ''));
                    setFrmDt(b.FrmDt);
                    setToDt(b.ToDt);
                    setTotalOrders(TotalOrders.toLocaleString());
                    setprvTotalOrders(prevTotalOrders.toLocaleString());
                    if (parseFloat(prevTotalOrders) > 0) {

                        const A = ((TotalOrders - prevTotalOrders) / prevTotalOrders) * 100.00;
                        const perc1 = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPerc1(perc1);
                        if (A < 0) {
                            setPercStyle('red');
                            setPercIconClass("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const cashorders = parseFloat(b.CashOrders.replace(/,/g, ''));
                    setCashOrders(cashorders);
                    const prvcashorders = parseFloat(b.PrvCashOrders.replace(/,/g, ''));
                    setprvCashOrders(prvcashorders);
                    if (prvcashorders > 0) {
                        const A = ((cashorders - prvcashorders) / prvcashorders) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setpercCashOrds(perccashorders);
                        if (A < 0) {
                            setPercStyleCashOrds('red');
                            setPercIconClassCashOrds("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const creditorders = parseFloat(b.CreditOrders.replace(/,/g, ''));
                    setCreditOrders(creditorders);
                    const prvcreditorders = parseFloat(b.PrvCreditOrders.replace(/,/g, ''));
                    setPrvCreditOrders(prvcreditorders);

                    if (prvcreditorders > 0) {
                        const A = ((creditorders - prvcreditorders) / prvcreditorders) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setpercCreditOrders(perccashorders);
                        if (A < 0) {
                            setPercStyleCreditOrders('red');
                            setPercIconClassCreditOrders("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const netsal = parseFloat(b.NetSal.replace(/,/g, ''));
                    setnetsal(netsal.toLocaleString());
                    const prvnetsal = parseFloat(b.PrvNetSal.replace(/,/g, ''));
                    setprvNetSal(prvnetsal.toLocaleString());

                    if (prvnetsal > 0) {
                        const A = ((netsal - prvnetsal) / prvnetsal) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercNetSal(perccashorders);
                        if (A < 0) {
                            setPercStyleNetSal('red');
                            setPercIconClassNetSal("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const gross = parseFloat(b.Gross.replace(/,/g, ''));
                    setGross(gross);
                    const prvgross = parseFloat(b.PrvGross.replace(/,/g, ''));
                    setprvGross(prvgross);

                    if (prvgross > 0) {
                        const A = ((gross - prvgross) / prvgross) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercGross(perccashorders);
                        if (A < 0) {
                            setPercStyleGross('red');
                            setPercIconClassGross("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const disc = parseFloat(b.Disc.replace(/,/g, ''));
                    setDisc(disc);
                    const prvdisc = parseFloat(b.PrvDisc.replace(/,/g, ''));
                    setprvDisc(prvdisc);

                    if (prvdisc > 0) {
                        const A = ((disc - prvdisc) / prvdisc) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercDisc(perccashorders);
                        if (A < 0) {
                            setPercStyleDisc('red');
                            setPercIconClassDisc("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const vat = parseFloat(b.VAT.replace(/,/g, ''));
                    setVAT(vat);
                    const prvvat = parseFloat(b.PrvVAT.replace(/,/g, ''));
                    setprvVAT(prvvat);

                    if (prvvat > 0) {
                        const A = ((vat - prvvat) / prvvat) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercVAT(perccashorders);
                        if (A < 0) {
                            setPercStyleVAT('red');
                            setPercIconClassVAT("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const cash = parseFloat(b.Cash.replace(/,/g, ''));
                    setCash(cash);
                    const prvcash = parseFloat(b.PrvCash.replace(/,/g, ''));
                    setprvCash(prvcash);

                    if (prvcash > 0) {
                        const A = ((cash - prvcash) / prvcash) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercCash(perccashorders);
                        if (A < 0) {
                            setPercStyleCash('red');
                            setPercIconClassCash("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const credit = parseFloat(b.Credit.replace(/,/g, ''));
                    setCredit(credit);
                    const prvcredit = parseFloat(b.PrvCredit.replace(/,/g, ''));
                    setprvCredit(prvcredit);

                    if (prvcredit > 0) {
                        const A = ((credit - prvcredit) / prvcredit) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercCredit(perccashorders);
                        if (A < 0) {
                            setPercStyleCredit('red');
                            setPercIconClassCredit("fas fa-caret-down dshsqrlbl");
                        }
                    }
                    const bnk = parseFloat(b.Bnk.replace(/,/g, ''));
                    setBnk(bnk);
                    const prvbnk = parseFloat(b.PrvBnk.replace(/,/g, ''));
                    setprvBnk(prvbnk);

                    if (prvbnk > 0) {
                        const A = ((bnk - prvbnk) / prvbnk) * 100.00;
                        const perccashorders = A >= 0 ? A.toFixed(2) : (-A).toFixed(2);
                        setPercBnk(perccashorders);
                        if (A < 0) {
                            setPercStyleBnk('red');
                            setPercIconClassBnk("fas fa-caret-down dshsqrlbl");
                        }
                    }
                })
                .catch(error => console.error('Error fetching data:', error));
        }

    }, [urlDsh]); // Empty dependency array means this effect runs once after the initial render

    return (
        <div className="app">
            <div className="row widget-content dshtp" style={{ backgroundColor: '#007ba7' }}>
                <button type="button" className="btn btn-secondary px-3 mx-2" data-toggle="modal" data-target="#filter-modal">
                    <i className="fa fa-filter"></i>
                </button>
                <button type="submit" className="btn btn-secondary px-3 mx-2">
                    <i className="fa fa-refresh" style={{ fontSize: '24px' }}></i>
                </button>

                <span className="card-title pt-2 grwhdr " style={{ padding: '0px' }}>{nameDsh}</span>
                <span className="card-title pt-2 flex-end" style={{ display: 'flex', marginLeft: '10px' }}>{formatDate(FrmDt)}</span>
                <span className="card-title pt-2 flex-end" style={{ display: 'flex', marginLeft: '10px' }}>{formatDate(ToDt)}</span>
        </div>
        <div class="container">
            <div class="row square-background services dshsqramts" style={{ backgroundImage: 'url(../fonts/images/pattern.png)' }}>
                    <div class="col-sm-12  col-md-8 service-wrap">
                        <div class=" service-section hover-program">




                                            <div class="widget-chat">

                                                    <div style={{ height: '100%', overflow: 'auto' }}>
                                                        <div id="chartContainerHrsDly" style={{ height: '25vh', width: '100%', overflow: 'hidden' }}></div>
                                                    </div>

                                            </div>

                            </div>


                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 dshcolsqramt">
                        <div id="spanProgram" class="col-sm-12 col-md-12 col-lg-12 col-xl-12  service-wrap">
                            <div class="card mb-3 widget-content service-section hover-program" style={{ backgroundColor: 'white' }}>
                                <div class="widget-content-wrapper text-white">
                                    <div class="col-sm-12" style={{ backgroundColor: 'transparent' }}>
                                        <div class="row">
                                            <div class="col-sm-12 cardscol" style={{ display: 'block' }}>
                                                <div class="widget-heading sqrHdr" >{SpOrders}</div>

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div className="col-sm-6 cardscol cardscollf" style={{ display: 'block' }}>
                                                <div className="widget-heading" style={{ color: 'black' }}>{totalOrders}</div>
                                                <div className="widget-subheading" style={{ color: percStyle }}>
                                                    <i className={percIconClass} style={{ color: percStyle }}></i>{Perc1}
                                                </div>

                                            </div>

                                            <div class="col-sm-6 cardscol cardscolR" style={{ display: 'block' }}>
                                                <div class="widget-heading" style={{ color: 'brown' }}>{PrvTotalOrders}</div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="spanProgram" class="col-sm-12 col-md-12 col-lg-12 col-xl-12  service-wrap" >
                            <div class="card mb-3 widget-content service-section hover-program" style={{ backgroundColor: 'white'}}>
                                <div class="widget-content-wrapper text-white ">
                                    <div class="col-sm-12" style={{ backgroundColor: 'transparent' }}>
                                        <div class="row">
                                            <div class="col-sm-12 cardscol" style={{ display: 'block' }}>
                                                <div class="widget-heading sqrHdr" >{pNetSales}</div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 cardscol cardscollf" style={{ display: 'block' }}>
                                                <div class="widget-heading" style={{ color: 'black' }}>{NetSal}</div>
                                                <div class="widget-subheading" style={{ color: percStyleNetSal }}>
                                                    <i class={percIconClassNetSal} style={{ color: percStyleNetSal }}></i>{PercNetSal}
                                                </div>

                                            </div>
                                            <div class="col-sm-6 cardscol cardscolR" style={{ display: 'block' }}>
                                                <div class="widget-heading" style={{ color: 'brown' }}>{PrvNetSal}</div>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>





            </div>
            </div>
        </div>
    );
}

export default App;